import Vue from 'vue';
import {ACCESS_TOKEN, USER_PHONE, USER_INFO, USER_AUTH, SYS_BUTTON_AUTH} from '@/store/mutation-types';
import { login, logout, getUserPermissions, queryPermissionsByUser } from "@/api/api"

const  user={
    state: {
        token: '',
        phone: '',
        username: '',
        realname: '',
        avatar: '',
        avatarPictureId: '',
        permissionList: [],
        info: {}
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_NAME: (state, { phone, username, realname }) => {
            state.phone = phone;
            state.username = username;
            state.realname = realname;
        },
        SET_AVATAR: (state, avatar, avatarPictureId) => {
            state.avatar = avatar
            state.avatarPictureId = avatarPictureId;
        },
        SET_INFO: (state, info) => {
            state.info = info
        },
        SET_PERMISSIONLIST: (state, permissionList) => {
            state.permissionList = permissionList
        },
    },
    actions: {
        // 测试
        mapActionsTest({ commit }, userInfo){
            return new Promise((resolve, reject) => {
                resolve();
            });
        },
        // 登录
        userLogin({ commit }, userInfo){
            return new Promise((resolve, reject) => {
                login(userInfo).then(response => {
                    //console.log('login result = ' + JSON.stringify(response));
                    if(response.code == 200){
                        const userInfo = response.result;
                        Vue.ls.set(ACCESS_TOKEN, userInfo.token, 7 * 24 * 60 * 60 * 1000)
                        Vue.ls.set(USER_PHONE, userInfo.phone, 7 * 24 * 60 * 60 * 1000)
                        Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
                        //console.log('userLogin userinfo = ' + JSON.stringify(userInfo));
                        commit('SET_TOKEN', userInfo.token)
                        commit('SET_NAME', { phone: userInfo.phone, username: userInfo.username, realname: userInfo.realname })
                        commit('SET_AVATAR', { avatar: userInfo.avatar, avatarPictureId: userInfo.avatarPictureId });
                        commit('SET_INFO', userInfo);
                        resolve(response)
                    }else{
                        reject(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 登出
        userLogout({ commit, state }) {
            return new Promise((resolve) => {
                let logoutToken = state.token;
                commit('SET_TOKEN', '');
                commit('SET_PERMISSIONLIST', []);
                Vue.ls.remove(ACCESS_TOKEN);
                logout(logoutToken).then(() => {
                    resolve()
                }).catch(() => {
                    resolve()
                })
            });
        },
        // 获取用户信息
        getPermissionList({ commit }) {
            return new Promise((resolve, reject) => {
                let token = Vue.ls.get(ACCESS_TOKEN);

                let moduleGroup  = window._CONFIG['moduleGroup'];
                let params = {
                    token:token,
                    moduleGroup: moduleGroup
                };
                queryPermissionsByUser(params).then(response => {
                    //console.log('/store/modules/user.js方法getUserPermissions返回 = ' + JSON.stringify(response));
                    if(response.code == 200 && response.result && response.result.menu && response.result.auth){
                        const menuData = response.result.menu;
                        const authData = response.result.auth;
                        const allAuthData = response.result.allAuth;
                        // 保存
                        sessionStorage.setItem(USER_AUTH,JSON.stringify(authData));
                        sessionStorage.setItem(SYS_BUTTON_AUTH,JSON.stringify(allAuthData));
                        if (menuData && menuData.length > 0) {
                            menuData.forEach((item, index) => {
                                if (item["children"]) {
                                    let hasChildrenMenu = item["children"].filter((i) => {
                                        return !i.hidden || i.hidden == false
                                    });
                                    if (hasChildrenMenu == null || hasChildrenMenu.length == 0) {
                                        item["hidden"] = true
                                    }
                                }
                            });

                            //console.log('getUserPermissions then SET_PERMISSIONLIST = ' + JSON.stringify(menuData) );
                            commit('SET_PERMISSIONLIST', menuData);
                        }else{
                            // 如果没有一个权限，那么则认为用户是没有资格进入的，强项要求他退出登录
                            reject('没有权限')
                        }
                    }else{
                        reject('getPermissionList: permissions must be a non-null array !')
                    }
                    resolve(response);
                }).catch(error => {
                    //console.log('queryPermissionsByUser error = ' + error);
                    reject(error)
                })
            });
        },

    }
}


export default user




